export type PortalRole = 'admin' | 'ops' | 'finance' | 'viewer';

export type PortalPermission =
  | 'portal:overview:read'
  | 'portal:operations:read'
  | 'portal:operations:write'
  | 'portal:finance:read'
  | 'portal:documents:read'
  | 'portal:users:manage';

const ROLE_PERMISSIONS: Record<PortalRole, PortalPermission[]> = {
  admin: [
    'portal:overview:read',
    'portal:operations:read',
    'portal:operations:write',
    'portal:finance:read',
    'portal:documents:read',
    'portal:users:manage',
  ],
  ops: [
    'portal:overview:read',
    'portal:operations:read',
    'portal:operations:write',
    'portal:documents:read',
  ],
  finance: [
    'portal:overview:read',
    'portal:finance:read',
    'portal:documents:read',
  ],
  viewer: [
    'portal:overview:read',
    'portal:operations:read',
    'portal:documents:read',
  ],
};

export function normalizePortalRole(role?: string | null): PortalRole {
  const normalized = String(role ?? '').trim().toLowerCase();
  if (['admin', 'owner', 'customer_admin', 'tenant_admin', 'manager'].includes(normalized)) return 'admin';
  if (['ops', 'operator', 'operations', 'transport', 'haulier', 'customer_ops'].includes(normalized)) return 'ops';
  if (['finance', 'billing', 'accounts', 'ap', 'ar'].includes(normalized)) return 'finance';
  return 'viewer';
}

export function portalPermissionsForRole(role?: string | null): PortalPermission[] {
  return ROLE_PERMISSIONS[normalizePortalRole(role)];
}

export function canUsePortalPermission(
  role: string | null | undefined,
  permission: PortalPermission,
  explicitPermissions?: string[] | null,
): boolean {
  if (explicitPermissions?.includes(permission) || explicitPermissions?.includes('portal:*')) return true;
  return portalPermissionsForRole(role).includes(permission);
}
